<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 0H6V2H10V0ZM2 1H5V2C5 2.55228 5.44772 3 6 3H10C10.5523 3 11 2.55228 11 2V1H14C14.5523 1 15 1.44772 15 2V11.1716C15 11.702 14.7893 12.2107 14.4142 12.5858L12.5858 14.4142C12.2107 14.7893 11.702 15 11.1716 15H2C1.44771 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1ZM4 6.75C4 6.33579 4.33579 6 4.75 6H11.25C11.6642 6 12 6.33579 12 6.75C12 7.16421 11.6642 7.5 11.25 7.5H4.75C4.33579 7.5 4 7.16421 4 6.75ZM4 10.25C4 9.83579 4.33579 9.5 4.75 9.5H8.25C8.66421 9.5 9 9.83579 9 10.25C9 10.6642 8.66421 11 8.25 11H4.75C4.33579 11 4 10.6642 4 10.25Z"
  />
</template>
